<div id="wrapper">
    <app-navbar></app-navbar>

    <app-sidebar [isCondensed]="isCondensed"></app-sidebar>

    <div class="content-page">
        <div class="content vendor-profile">
            <div class="content-pane">
                <div class="container-fluid">
                    <div class="breadcrumb">
                        <span class="breadcrumb-item">
                            <a href="javascript:void(0)">PayEXAP</a>
                        </span>
                        <span class="px-2"
                            ><i class="ri-arrow-right-s-line"></i
                        ></span>
                        <span class="breadcrumb-item" aria-current="page">
                            <a routerLink="/invoices">Invoices</a>
                        </span>
                    </div>
                    <div class="info-pane mb-3">
                        <p>The Vendor Master Data is currently not editable.</p>
                        <p>
                            If you find any discrepancies in the data below,
                            please reach out to the Location buyer for necessary
                            updation.
                        </p>
                    </div>
                    <ng-container *ngIf="loading">
                        <div class="text-center">
                            <app-loader></app-loader>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="!loading">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="data-pane mb-4">
                                    <h5 class="mb-2">
                                        Vendor Personal Details
                                    </h5>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="data-tag mb-4">
                                                <h6>Vendor Name</h6>
                                                <p>
                                                    {{ vendorData.vendor_name }}
                                                </p>
                                                <p
                                                    *ngIf="
                                                        vendorData.vendor_name ===
                                                        ''
                                                    "
                                                >
                                                    Not available
                                                </p>
                                            </div>

                                            <div class="data-tag mb-4">
                                                <h6>Country</h6>
                                                <p>
                                                    {{
                                                        vendorData.vendor_country
                                                    }}
                                                </p>
                                                <p
                                                    *ngIf="
                                                        vendorData.vendor_country ===
                                                        ''
                                                    "
                                                >
                                                    Not available
                                                </p>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="data-tag mb-4">
                                                <h6>Vendor Code</h6>
                                                <p>
                                                    {{ vendorData.vendor_code }}
                                                </p>
                                                <p
                                                    *ngIf="
                                                        vendorData.vendor_code ===
                                                        ''
                                                    "
                                                >
                                                    Not available
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="data-pane mb-4">
                                    <h5 class="mb-2">Vendor Contact Details</h5>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="data-tag mb-4">
                                                <h6>Postal Code</h6>
                                                <p>
                                                    {{
                                                        vendorData.vendor_postal_code
                                                    }}
                                                </p>
                                                <p
                                                    *ngIf="
                                                        vendorData.vendor_postal_code ===
                                                        ''
                                                    "
                                                >
                                                    Not available
                                                </p>
                                            </div>

                                            <div class="data-tag mb-4">
                                                <h6>Region</h6>
                                                <p
                                                    *ngIf="
                                                        vendorData.vendor_region !==
                                                        null
                                                    "
                                                >
                                                    {{
                                                        vendorData.vendor_region
                                                    }}
                                                </p>
                                                <p
                                                    *ngIf="
                                                        vendorData.vendor_region ===
                                                            null ||
                                                        vendorData.vendor_region ===
                                                            ''
                                                    "
                                                >
                                                    Not available
                                                </p>
                                            </div>

                                            <div class="data-tag mb-4">
                                                <h6>City</h6>
                                                <p>
                                                    {{ vendorData.vendor_city }}
                                                </p>
                                                <p
                                                    *ngIf="
                                                        vendorData.vendor_city ===
                                                        ''
                                                    "
                                                >
                                                    Not available
                                                </p>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="data-tag mb-4">
                                                <h6>Email Address</h6>
                                                <p>
                                                    {{
                                                        vendorData.vendor_email
                                                    }}
                                                </p>
                                                <p
                                                    *ngIf="
                                                        vendorData.vendor_email ===
                                                        ''
                                                    "
                                                >
                                                    Not available
                                                </p>
                                            </div>

                                            <div class="data-tag mb-4">
                                                <h6>Contact Number</h6>
                                                <p>
                                                    {{
                                                        vendorData.vendor_mobile
                                                    }}
                                                </p>
                                                <p
                                                    *ngIf="
                                                        vendorData.vendor_mobile ===
                                                        ''
                                                    "
                                                >
                                                    Not available
                                                </p>
                                            </div>

                                            <div class="data-tag mb-4">
                                                <h6>Address</h6>
                                                <p>
                                                    {{
                                                        vendorData.vendor_address
                                                    }}
                                                </p>
                                                <p
                                                    *ngIf="
                                                        vendorData.vendor_address ===
                                                        ''
                                                    "
                                                >
                                                    Not available
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="data-pane mb-2">
                                    <h5 class="mb-2">Vendor Bank Details</h5>

                                    <table
                                        aria-describedby="bank-details"
                                        class="table mb-0 toggle-arrow-tiny tablet breakpoint bank-details"
                                    >
                                        <thead>
                                            <tr>
                                                <th>Bank Name</th>

                                                <th>Bank Country</th>

                                                <th>Account No.</th>
                                                <th>Account Holder</th>
                                                <th>IFSC Code</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                class="footable-even footable-detail-show"
                                                *ngFor="
                                                    let bank of vendorData.bank_details
                                                "
                                            >
                                                <td
                                                    *ngIf="
                                                        bank.bank_name !== ''
                                                    "
                                                >
                                                    {{ bank.bank_name }}
                                                </td>
                                                <td
                                                    *ngIf="
                                                        bank.bank_name === ''
                                                    "
                                                >
                                                    NA
                                                </td>

                                                <td
                                                    *ngIf="
                                                        bank.bank_county !== ''
                                                    "
                                                >
                                                    {{ bank.bank_county }}
                                                </td>
                                                <td
                                                    *ngIf="
                                                        bank.bank_county === ''
                                                    "
                                                >
                                                    NA
                                                </td>
                                                <td
                                                    *ngIf="
                                                        bank.bank_account_no !==
                                                        ''
                                                    "
                                                >
                                                    {{ bank.bank_account_no }}
                                                </td>
                                                <td
                                                    *ngIf="
                                                        bank.bank_account_no ===
                                                        ''
                                                    "
                                                >
                                                    NA
                                                </td>
                                                <td
                                                    *ngIf="
                                                        bank.bank_account_holder !==
                                                        ''
                                                    "
                                                >
                                                    {{
                                                        bank.bank_account_holder
                                                    }}
                                                </td>
                                                <td
                                                    *ngIf="
                                                        bank.bank_account_holder ===
                                                        ''
                                                    "
                                                >
                                                    NA
                                                </td>
                                                <td
                                                    *ngIf="
                                                        bank.bank_ifsc_code !==
                                                        ''
                                                    "
                                                >
                                                    {{ bank.bank_ifsc_code }}
                                                </td>
                                                <td
                                                    *ngIf="
                                                        bank.bank_ifsc_code ===
                                                        ''
                                                    "
                                                >
                                                    NA
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="data-pane pb-4 p5-2">
                                    <h5 class="mb-2">
                                        Vendor Statutory Details
                                    </h5>
                                    <div class="row">
                                        <div class="col-md-6 py">
                                            <div class="data-tag mb-4">
                                                <h6>PAN Number</h6>
                                                <p>
                                                    {{ vendorData.vendor_pan }}
                                                </p>
                                                <p
                                                    *ngIf="
                                                        vendorData.vendor_pan ===
                                                        ''
                                                    "
                                                >
                                                    Not available
                                                </p>
                                            </div>
                                            <div class="data-tag mb-4">
                                                <h6>Tax Registration Number</h6>
                                                <p
                                                    *ngIf="
                                                        vendorData.vendor_gstin ===
                                                        ''
                                                    "
                                                >
                                                    Not available
                                                </p>
                                                <p
                                                    *ngIf="
                                                        vendorData.vendor_gstin !==
                                                        ''
                                                    "
                                                >
                                                    {{
                                                        vendorData.vendor_gstin
                                                    }}
                                                </p>
                                            </div>
                                            <div class="data-tag mb-4">
                                                <h6>Tax Registration Status</h6>
                                                <p>
                                                    {{
                                                        vendorData.vendor_gstin_status
                                                    }}
                                                </p>
                                                <p
                                                    *ngIf="
                                                        vendorData.vendor_gstin_status ===
                                                        ''
                                                    "
                                                >
                                                    Not available
                                                </p>
                                            </div>
                                            <div class="data-tag mb-4">
                                                <h6>IRN E-invoice status</h6>
                                                <p>
                                                    {{
                                                        vendorData.vendor_einvoice_status
                                                    }}
                                                </p>
                                                <p
                                                    *ngIf="
                                                        vendorData.vendor_einvoice_status ===
                                                        ''
                                                    "
                                                >
                                                    Not available
                                                </p>
                                            </div>

                                            <div class="data-tag mb-4">
                                                <h6>
                                                    Tax Return Filing Status
                                                </h6>
                                                <p *ngIf="statusExist">
                                                    {{
                                                        vendorData.tax_return_status
                                                    }}
                                                </p>
                                                <p *ngIf="!statusExist">
                                                    Not available
                                                </p>
                                            </div>

                                            <div class="data-tag mb-4">
                                                <h6>
                                                    Tax Return Filing Frequency
                                                </h6>
                                                <p *ngIf="freqExist">
                                                    {{
                                                        vendorData.tax_return_frequency
                                                    }}
                                                </p>
                                                <p *ngIf="!freqExist">
                                                    Not available
                                                </p>
                                            </div>

                                            <div class="data-tag mb-4">
                                                <h6>Last Tax Filing Date</h6>
                                                <p
                                                    *ngIf="
                                                        vendorData.vendor_gstr_filing_date !==
                                                        ''
                                                    "
                                                >
                                                    {{
                                                        vendorData.vendor_gstr_filing_date
                                                    }}
                                                </p>
                                                <p
                                                    *ngIf="
                                                        vendorData.vendor_gstr_filing_date ===
                                                        ''
                                                    "
                                                >
                                                    Not available
                                                </p>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="data-tag mb-4">
                                                <h6>Industry</h6>
                                                <p
                                                    *ngIf="
                                                        vendorData.vendor_industry !==
                                                        null
                                                    "
                                                >
                                                    {{
                                                        vendorData.vendor_industry
                                                    }}
                                                </p>
                                                <p
                                                    *ngIf="
                                                        vendorData.vendor_industry ===
                                                        null
                                                    "
                                                >
                                                    Not available
                                                </p>
                                            </div>
                                            <div class="data-tag mb-4">
                                                <h6>URN Number</h6>
                                                <p
                                                    *ngIf="
                                                        vendorData.vendor_unr !==
                                                        ''
                                                    "
                                                >
                                                    {{ vendorData.vendor_unr }}
                                                </p>
                                                <p
                                                    *ngIf="
                                                        vendorData.vendor_unr ===
                                                        ''
                                                    "
                                                >
                                                    Not available
                                                </p>
                                            </div>
                                            <div class="data-tag mb-4">
                                                <h6>
                                                    MSME Validity Start Date
                                                </h6>
                                                <p
                                                    *ngIf="
                                                        vendorData.vendor_msme_start_date !==
                                                        ''
                                                    "
                                                >
                                                    {{
                                                        vendorData.vendor_msme_start_date
                                                    }}
                                                </p>
                                                <p
                                                    *ngIf="
                                                        vendorData.vendor_msme_start_date ===
                                                        ''
                                                    "
                                                >
                                                    Not available
                                                </p>
                                            </div>
                                            <div class="data-tag mb-4">
                                                <h6>MSME Validity End Date</h6>
                                                <p
                                                    *ngIf="
                                                        vendorData.vendor_msme_end_date !==
                                                        ''
                                                    "
                                                >
                                                    {{
                                                        vendorData.vendor_msme_end_date
                                                    }}
                                                </p>
                                                <p
                                                    *ngIf="
                                                        vendorData.vendor_msme_end_date ===
                                                        ''
                                                    "
                                                >
                                                    Not available
                                                </p>
                                            </div>
                                            <div
                                                class="td-codes"
                                                *ngFor="
                                                    let td_code of vendorData.tds_codes;
                                                    let lastItem = last
                                                "
                                            >
                                                <div
                                                    class="data-tag mb-4"
                                                    *ngIf="
                                                        td_code.tds_code_section !==
                                                        ''
                                                    "
                                                >
                                                    <h6>
                                                        TDS Codes Applicable -
                                                        Section
                                                    </h6>
                                                    <p>
                                                        {{
                                                            td_code.tds_code_section
                                                        }}
                                                    </p>
                                                </div>
                                                <div
                                                    class="data-tag mb-4"
                                                    *ngIf="
                                                        td_code.tds_code_tax_code !==
                                                        ''
                                                    "
                                                >
                                                    <h6>
                                                        TDS Codes Applicable -
                                                        Tax Code
                                                    </h6>
                                                    <p>
                                                        {{
                                                            td_code.tds_code_tax_code
                                                        }}
                                                    </p>
                                                </div>
                                                <hr *ngIf="!lastItem" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>
